import { jsx as e, jsxs as r } from "react/jsx-runtime";
import { c as N } from "../../../index-Cu0xwYjD.js";
import { forwardRef as w } from "react";
import { ErrorText as W } from "../ErrorText/ErrorText.js";
import { FormGroup as B } from "../FormGroup/FormGroup.js";
import { HintText as C } from "../HintText/HintText.js";
import { LabelText as j } from "../LabelText/LabelText.js";
import { NumberInput as h } from "../NumberInput/NumberInput.js";
import { Stack as c } from "../Stack/Stack.js";
import { SubLabelText as y } from "../SubLabelText/SubLabelText.js";
import '../../../assets/DateField.css';const D = "_inlineFields_4sllu_3", E = "_fullWidth_4sllu_12", L = "_dayField_4sllu_26", S = "_monthField_4sllu_30", k = "_yearField_4sllu_34", t = {
  inlineFields: D,
  fullWidth: E,
  dayField: L,
  monthField: S,
  yearField: k
}, P = w(
  ({
    id: l,
    name: a,
    label: b,
    hint: F,
    error: d,
    optional: _ = !1,
    fullWidth: v = !1,
    readOnly: s = !1,
    value: n = {
      day: "",
      month: "",
      year: ""
    },
    onChange: f,
    "data-testid": i
  }, $) => {
    const o = !!d, m = (x) => (g) => {
      f && f({
        ...n,
        [x]: g.target.value
      });
    }, u = `${l}-month`, p = `${l}-year`;
    return /* @__PURE__ */ e(B, { "data-error": o || void 0, children: /* @__PURE__ */ r("fieldset", { children: [
      /* @__PURE__ */ r("legend", { children: [
        /* @__PURE__ */ r(j, { children: [
          b,
          _ ? " (optional)" : null
        ] }),
        F ? /* @__PURE__ */ e(C, { children: F }) : null,
        /* @__PURE__ */ e(
          "div",
          {
            id: `error-${l}`,
            role: "alert",
            style: o ? {} : { margin: 0 },
            children: d ? /* @__PURE__ */ e(W, { children: d }) : null
          }
        )
      ] }),
      /* @__PURE__ */ r(
        "div",
        {
          className: N(t.inlineFields, {
            [t.fullWidth]: v
          }),
          children: [
            /* @__PURE__ */ r(c, { className: t.dayField, spaceBetween: 1, children: [
              /* @__PURE__ */ e(y, { htmlFor: l, id: "label-day", children: "Day" }),
              /* @__PURE__ */ e(
                h,
                {
                  ref: $,
                  id: l,
                  "data-testid": i,
                  name: a,
                  "aria-invalid": o || void 0,
                  "aria-labelledby": `label-day error-${l}`,
                  value: n.day,
                  readOnly: s,
                  onChange: m("day")
                }
              )
            ] }),
            /* @__PURE__ */ r(c, { className: t.monthField, spaceBetween: 1, children: [
              /* @__PURE__ */ e(y, { htmlFor: u, id: "label-month", children: "Month" }),
              /* @__PURE__ */ e(
                h,
                {
                  id: u,
                  "data-testid": i && `${i}-month`,
                  name: a && `${a}-month`,
                  "aria-invalid": o || void 0,
                  "aria-labelledby": `label-month error-${l}`,
                  value: n.month,
                  readOnly: s,
                  onChange: m("month")
                }
              )
            ] }),
            /* @__PURE__ */ r(c, { className: t.yearField, spaceBetween: 1, children: [
              /* @__PURE__ */ e(y, { htmlFor: p, id: "label-year", children: "Year" }),
              /* @__PURE__ */ e(
                h,
                {
                  id: p,
                  "data-testid": i && `${i}-year`,
                  name: a && `${a}-year`,
                  "aria-invalid": o || void 0,
                  "aria-labelledby": `label-year error-${l}`,
                  value: n.year,
                  readOnly: s,
                  onChange: m("year")
                }
              )
            ] })
          ]
        }
      )
    ] }) });
  }
);
export {
  P as DateField
};
